import React, { Component } from "react";
import {
  Checkbox,
  Typography,
  withStyles,
  FormControlLabel,
  Button,
  Popover,
  Divider,
  Tooltip,
  Grid,
  Switch,
} from "@material-ui/core";
import TodayIcon from "@material-ui/icons/Today";
import HomeWorkIcon from "@material-ui/icons/HomeWork";

const FilterNameTypography = withStyles({
  root: {
    color: "#082d66",
  },
})(Typography);

const ValuesTypography = withStyles({
  root: {
    color: "#8091af",
  },
})(Typography);

const SelectFilterButton = withStyles({
  root: {
    color: "#007bff",
    width: "100%",
    justifyContent: "end",
  },
  text: {
    padding: "10px 0px",
  },
})(Button);

const SelectPopover = withStyles({
  paper: {
    paddingLeft: "7px",
    paddingRight: "7px",
  },
})(Popover);

const SelectCheckbox = withStyles({
  root: {
    color: "#007bff",
  },
})(Checkbox);

const SwitchTypography = withStyles({
  root: {
    color: "#007bff",
  },
})(Typography);

const FilterSwitch = withStyles({
  checked: {},
  track: {
    backgroundColor: "#007bff",
    opacity: "0.3",
  },
  colorDefault: {
    color: "#007bff",
  },
})(Switch);

const SwitchGrid = withStyles({
  root: {
    marginBottom: "0px",
    marginLeft: "2px",
  },
})(Grid);

class FlagSelectFilter extends Component {
  state = {
    description: this.props.description,
    values: this.props.values,
    selectedValues: this.props.selectedValues,
    flag: this.props.flagValue,
    anchorEl: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedValues !== this.props.selectedValues) {
      this.setState({ selectedValues: this.props.selectedValues });
    }
    if (prevProps.flagValue !== this.props.flagValue) {
      this.setState({ flag: this.props.flagValue });
    }
  }

  render() {
    return (
      <div className="filter-box">
        <FilterNameTypography variant="h6" id="range-slider">
          {this.state.description}
        </FilterNameTypography>
        {/* <ValuesTypography variant="body2">
          {this.renderFlagValue()}
          <br />
          {this.renderCurrentValues()}
        </ValuesTypography> */}
        {this.renderFlagSwitch()}
        {/* {this.renderSelectMenu()}
        <Tooltip title="vybrani konkretnich hodnot" placement="right">
          <SelectFilterButton variant="text" onClick={this.handleOpenMenu}>
            {this.renderIcon()}
            {" vyber " + this.state.description}
          </SelectFilterButton>
        </Tooltip> */}
      </div>
    );
  }

  renderFlagSwitch = () => {
    return (
      <SwitchTypography variant="button" component="div">
        <SwitchGrid component="label" container spacing={0} alignItems="center">
          <Grid item>všechny</Grid>
          <Grid item>
            <FilterSwitch
              checked={this.state.flag}
              onChange={this.handleChange}
              color="default"
            />
          </Grid>
          <Grid item>právě bežící</Grid>
        </SwitchGrid>
      </SwitchTypography>
    );
  };

  renderSelectMenu = () => {
    return (
      <SelectPopover
        keepMounted
        anchorEl={this.state.anchorEl}
        open={Boolean(this.state.anchorEl)}
        onClose={this.handleCloseMenu}
        anchorOrigin={{
          horizontal: "right",
        }}
      >
        {this.renderSelectAllCheckbox()}
        <Divider></Divider>
        {this.renderValuesCheckboxes()}
      </SelectPopover>
    );
  };

  handleOpenMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleCloseMenu = () => {
    this.setState({
      anchorEl: null,
    });
  };

  renderIcon = () => {
    const icon = this.props.icon;
    if (icon === "years") {
      return <TodayIcon style={{ paddingRight: "5px" }} />;
    } else if (icon === "client_type") {
      return <HomeWorkIcon style={{ paddingRight: "5px" }} />;
    } else {
      //unknown icon
      return;
    }
  };

  renderSelectAllCheckbox = () => {
    return (
      <FormControlLabel
        control={
          <SelectCheckbox
            checked={this.isEveryValueChecked()}
            onChange={this.handleChangeSelectAll}
            color="default"
          />
        }
        label="všechny"
      ></FormControlLabel>
    );
  };

  isEveryValueChecked = () => {
    return this.props.selectedValues.length === this.props.values.length;
  };

  renderValuesCheckboxes = () => {
    this.state.values.sort();
    return (
      <div>
        {this.state.values.map((value) => {
          return (
            <FormControlLabel
              control={
                <SelectCheckbox
                  checked={this.valueInsideSelected(value)}
                  onChange={this.handleChangeSelectedValues(value)}
                  name={value}
                  color="default"
                />
              }
              label={value}
            ></FormControlLabel>
          );
        })}
      </div>
    );
  };

  valueInsideSelected = (value) => {
    return this.state.selectedValues.includes(value);
  };

  handleChangeSelectedValues = (value) => () => {
    const valueIndex = this.state.selectedValues.indexOf(value);
    if (valueIndex === -1) {
      this.state.selectedValues.push(value);
    } else {
      this.state.selectedValues.splice(valueIndex, 1);
    }
    this.props.changeFilterValue(this.state.selectedValues, this.state.flag);
  };

  renderCurrentValues = () => {
    if (this.state.selectedValues.length === 0) {
      return "Nic není vybráno";
    }
    this.state.selectedValues.sort();
    return this.state.selectedValues.map((value) => value + ", ");
  };

  //Hardcoded values for specific case (filtering Years)
  renderFlagValue = () => {
    if (this.state.flag) {
      return "První ročník v letech:";
    } else {
      return "Působnost v letech:";
    }
  };

  makeArrayCopy(array) {
    var arrayCopy = [];
    array.forEach((value) => arrayCopy.push(value));
    return arrayCopy;
  }

  handleChangeSelectAll = () => {
    const isChecked = this.isEveryValueChecked();
    if (!isChecked) {
      const valuesCopy = this.makeArrayCopy(this.state.values);
      this.props.changeFilterValue(valuesCopy, this.state.flag);
    }
  };

  handleChange = () => {
    const newFlag = !this.state.flag;
    this.state.flag = newFlag;
    this.props.changeFilterValue(this.state.selectedValues, this.state.flag);
  };
}

export default FlagSelectFilter;
